import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HiHome, HiMagnifyingGlass, HiSparkles } from "react-icons/hi2";
import { useAuth } from "../../contexts/AuthContext";
import { isUnderAge } from "../../utils/dateUtils";

const BottomBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useAuth();

  const isActive = (path: string) => location.pathname === path;

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  // STAXS is a social feature — restricted to users aged 16 and above.
  if (isUnderAge(userData?.dob, 16)) {
    return null;
  }

  return (
    <div className="fixed bottom-10 left-4 right-4 z-50">
      <div className="bg-black backdrop-blur-sm bg-opacity-80 rounded-full border border-base-100 shadow-2xl mx-auto max-w-sm">
        <div className="flex justify-around items-center py-2 px-6">
          <button
            onClick={() => handleNavigation("/staxs")}
            className={`flex flex-col items-center justify-center gap-1 py-2 px-3 transition-colors ${
              isActive("/staxs")
                ? "text-white"
                : "text-base-content/50 hover:text-base-content/50"
            }`}
          >
            <HiHome className="w-6 h-6" />
            <span className="text-xs font-medium">Home</span>
          </button>

          <button
            onClick={() => handleNavigation("/staxs/explore")}
            className={`flex flex-col items-center justify-center gap-1 py-2 px-3 transition-colors ${
              isActive("/staxs/explore")
                ? "text-white"
                : "text-base-content/50 hover:text-base-content/50"
            }`}
          >
            <HiMagnifyingGlass className="w-6 h-6" />
            <span className="text-xs font-medium">Explore</span>
          </button>

          <button
            onClick={() => handleNavigation("/staxs/mint")}
            className={`flex flex-col items-center justify-center gap-1 py-2 px-3 transition-colors ${
              isActive("/staxs/mint")
                ? "text-white"
                : "text-base-content/50 hover:text-base-content/50"
            }`}
          >
            <HiSparkles className="w-6 h-6" />
            <span className="text-xs font-medium">Mint</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
